<template>
  <b-modal id="mdlEditRigaDocumento" @shown="onModalShown" ref="mdlEditRigaDocumento" :title="getTitoloModal()"
    modal-class="sa-modal-static-scroll" size="xl" @show="onShowRigaDocumento" @hide="onHideRigaDocumento"
    style="height: 100%" ok-hide>
    <b-alert :show="showAlertArticoloPresente" variant="warning" class="text-center shadow-sm rounded-3"
      style="width: 100%">
      <b-row class="align-items-center">
        <b-col cols="12" class="mb-3">
          <h5 class="mb-0">Codice Articolo e Descrizione gia presenti nel documento, aumentare quantita ?</h5>
          <small class="mb-0">Vuoi davvero procedere con questa azione?</small>
        </b-col>
        <b-col cols="12" class="text-end">
          <b-button variant="success" class="px-4" @click="onClickSiArticoloQuantita">Sì</b-button>
          <b-button variant="danger" class="px-4" @click="onClickNoArticoloQuantita">No</b-button>
        </b-col>
      </b-row>
    </b-alert>
    <div class="sa-flexbox">
      <div class="sa-flexbox-header">
        <form ref="form">
          <div class="sa-form-section sa-search-box">
            <b-row>
              <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <label class="sa-search-box-label">{{ this.$i18n.t("billing.lblProductCode") }}</label>
                <div class="sa-search-search-wrapper">
                  <input class="sa-search-box-input" v-model="rigaDocumento.codiceArticolo"
                    placeholder="Codice Articolo" />
                  <button @click="onRicercaArticolo" class="sa-prescrizione-btn-search" title="Cerca">
                    <i class="fas fa-search"></i>
                  </button>
                </div>
              </b-col>
              <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">

                <label class="sa-search-box-label">{{ this.$i18n.t("billing.lblDescription") }}</label>
                <div class="sa-search-search-wrapper">
                  <input class="sa-search-box-input" v-model="rigaDocumento.descrizione" placeholder="Descrizione" />
                  <button @click="onRicercaArticolo" class="sa-prescrizione-btn-search" title="Cerca">
                    <i class="fas fa-search"></i>
                  </button>
                </div>
              </b-col>
              <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                <label class="sa-search-box-label">{{ this.$i18n.t("billing.lblUnitOfMeasure") }}</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="rigaDocumento.umCodice"
                  class="sa-search-input mb-2 mr-sm-2 mb-sm-0" :options="getUnitaMisuraArticoli" :value="null"
                  text-field="descrizioneMultiplo" @change="onChangeUnitaMisura" value-field="codiceMoltiplicatore"
                  required :state="rigaDocumento.idUnitaMisuraState">
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
              </b-col>
              <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <label class="sa-search-box-label">{{ this.$i18n.t("billing.lblTipoSpesa") }}</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="rigaDocumento.codiceTipoSpesa"
                  class="sa-search-input mb-2 mr-sm-2 mb-sm-0" :options="contabilitaTipoSpesaOptions" :value="null"
                  text-field="descrizione" value-field="codice" required :state="rigaDocumento.idTipoSpesaState">
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
              </b-col>

              <b-col cols="12" xs="12" sm="3" md="3" lg="3" xl="3">
                <label class="sa-search-box-label">{{ this.$i18n.t("billing.lblIva") }}</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="rigaDocumento.ivaCodice"
                  @change="onChangeIva" class="sa-search-input mb-2 mr-sm-2 mb-sm-0" :options="contabilitaIvaOptions"
                  :value="null" text-field="descrizioneIva" value-field="codiceIva" required
                  :state="rigaDocumento.idIvaState">
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
              </b-col>
              <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                <label class="sa-search-box-label">{{ this.$i18n.t("billing.lblQuantity") }}</label>
                <input type="number" class="sa-search-box-input" v-model="rigaDocumento.quantita" placeholder="Quantità"
                  :state="rigaDocumento.quantitaState" />
              </b-col>
              <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                <label class="sa-search-box-label">Prez.Uni.</label>
                <input step="0.01" min="0.00" type="number" class="sa-search-box-input"
                  v-model="rigaDocumento.prezzoUnitario" placeholder="Quantità"
                  :state="rigaDocumento.prezzoUnitarioState" />
              </b-col>
              <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                <label class="sa-search-box-label">{{ this.$i18n.t("billing.lblDiscountPercentage") }}</label>
                <input step="10" max="100" min="0" type="number" class="sa-search-box-input"
                  v-model="rigaDocumento.sconto" placeholder="Quantità" :state="rigaDocumento.scontoState" />
              </b-col>
              <b-col cols="12" xs="12" sm="12" :md="!isGestioneLottoMatricole ? '3' : '2'"
                :lg="!isGestioneLottoMatricole ? '3' : '2'" :xl="!isGestioneLottoMatricole ? '3' : '2'">
                <label class="sa-search-box-label">{{ this.$i18n.t("billing.lblTotalLineAmount") }}</label>
                <input step="0.001" type="number" class="sa-search-box-input" v-model="rigaDocumento.sconto"
                  placeholder="Totale Riga" disabled />
              </b-col>
            </b-row>
          </div>
        </form>
      </div>
      <div class="sa-flexbox-body">
        <div class="sa-flex-box-main" style="background-color: red">
          <div class="sa-flex-box-main-header">
            <div style="display: flex ; justify-content: end; margin-top:10px">
              <b-button size="sm" variant="outline-success outline-primary-noborder float-sm-right" :hidden="false"
                @click="onClickAggiungiArticoloNonPresente" class="mb-2">
                <font-awesome-icon icon="plus"> </font-awesome-icon>
                Aggiungi Articolo
              </b-button>
            </div>
          </div>
          <div class="sa-flex-box-main-body">
            <div class="sa-flex-box-main-content">
              <magazzino-articoli-giacenze-list-component ref="cmpMagazzinoArticoliGiacenzeListComponent"
                @onRowSelectedArticoliItems="onRowSelectedArticoliItems"
                @onSelectedLottoMatricola="onRowSelectedLottoMatricola" @onAddLottoMatricola="onAddLottoMatricola"
                @updateRowNumberGiacenza="onUpdateRowNumberGiacenza" />
            </div>
          </div>
          <div class="sa-flex-box-main-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
              <b-col lg="3">
                <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rowsGiacenza }}</p>
              </b-col>
              <b-col lg="9">
                <b-pagination v-model="paginationArticoli.page" :total-rows="rowsGiacenza"
                  :per-page="paginationArticoli.forPage" align="right" size="sm"></b-pagination>
              </b-col>
            </b-row>
          </div>
        </div>
        <contabilita-documento-riga-aggiungi-articolo-box-component @afterSavedArticolo="onAfterSavedArticolo"
          ref="cmpContabilitaDocumentoRigaAggiungiArticoloBoxComponent" />
      </div>
      <div class="sa-flexbox-footer"></div>
    </div>
    <template #modal-footer>
      <div class="sa-padding-right text-right col" v-if="!isBoxAggiungiArticoloOpen">
        <b-button type="button" variant="secondary" @click="hide()">Chiudi</b-button>
        <b-button type="button" variant="success" @click="onOkRigaDocumento"><span
            v-if="isModificaRigaDocumento">Modifica Riga</span>
          <span v-else>Aggiungi Riga</span></b-button>
      </div>
      <div class="sa-padding-right text-right col" v-else>
        <b-button type="button" variant="danger" @click="onClickChiudiBoxArticoloNonPresente">Annulla</b-button>
        <b-button type="button" variant="info" @click="onSalvaNuovoArticoloChiudi">Salva e chiudi</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import MagazzinoArticoliGiacenzeListComponent from "../../magazzino/components/MagazzinoArticoliGiacenzeListComponent.vue";
import ContabilitaDocumentoRigaAggiungiArticoloBoxComponent from "./ContabilitaDocumentoRigaAggiungiArticoloBoxComponent.vue";
import ContabilitaMixin from "../mixins/ContabilitaMixin";
import MagazzinoMixins from "../../magazzino/mixins/MagazzinoMixins";
// import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  mixins: [ContabilitaMixin, MagazzinoMixins, UtilityMixin],
  components: { MagazzinoArticoliGiacenzeListComponent, ContabilitaDocumentoRigaAggiungiArticoloBoxComponent, },//DatePicker
  data() {
    return {
      isBoxAggiungiArticoloOpen: false,
      showAlertArticoloPresente: false,
      presidio: {},
      jsonData: {},
      rowsGiacenza: 0,
      paginationArticoli: {
        page: 1,
        forPage: 50
      },
      isGestioneLottoMatricole: false,
      isModificaRigaDocumento: false,
      arraySelezionati: {
        articolo: null,
      },
      rigaDocumentoSelezionata: null,
      filtroRicercaArticolo: {
        nomeArticolo: null,
        codiceArticolo: null,
        page: 1,
        forPage: 50
      },

      rigaDocumento: {
        id: "-1",
        idArticolo: null,
        codiceArticolo: null,
        descrizione: null,
        umCodice: null,
        umDescrizione: null,
        umMultiplo: 0,
        quantita: 1,
        prezzoUnitario: 0,
        sconto: 0,
        ivaCodice: null,
        ivaDescrizione: null,
        ivaAliquota: 0,
        codiceTipoSpesa: null,
        descrizioneImballo: null,
        colli: 0,
        totaleRiga: 0,
        lottiScadenze: [],
        documentoRiferimentoDescrizione: null,
        documentoRiferimentoId: null,
        documentoRiferimentoRigaId: null,
        documentoRiferimentoRigaQuantita: null,
      },

    };
  },
  watch: {
    'paginationArticoli.page': function () {
      this.ricercaArticolo()
    },
  },
  computed: {
    getUnitaMisuraArticoli() {
      let returnValue = [];
      if (this.arraySelezionati.articolo) {
        let idUm = this.arraySelezionati.articolo[0].umId
        let idUmBase = this.arraySelezionati.articolo[0].umBaseId;
        console.log(this.magazzinoArticoliUnitaMisuraOptions);

        console.log(this.magazzinoArticoliUnitaMisuraOptions.filter((e) => e.id === idUm || e.id === idUmBase));

        returnValue = this.magazzinoArticoliUnitaMisuraOptions.filter((e) => e.id === idUm || e.id === idUmBase);
      }

      return returnValue;
    }

  },
  mounted() {
    this.loadDefaultData();
  },
  methods: {
    onClickAddRiga(jsonData) {
      this.jsonData = jsonData;
      this.onResetRigaDocumento();
      this.show();
    },
    loadDefaultData() {
      this.mangazzinoArticoliUnitaMisuraLoadData();
      this.contabilitaTipoSpesaLoadData();
      this.contabilitaTabellaIvaLoadData();
      this.getPresidio();
    },
    show() {
      this.$refs.mdlEditRigaDocumento.show();
    },
    hide() {
      this.$refs.mdlEditRigaDocumento.hide();
      this.onResetRigaDocumento();
    },
    getTitoloModal() {
      return this.isBoxAggiungiArticoloOpen ? "Crea Nuovo Articolo" : "Crea Riga Documento";
    },
    onModalShown() {
      this.ricercaArticolo();
      if (this.isModificaRigaDocumento) {
        this.$refs.cmpMagazzinoArticoliGiacenzeListComponent.onModificaRow(this.rigaDocumentoSelezionata);
      }
    },

    onShowRigaDocumento() {
      this.showAlertArticoloPresente = false;
    },
    onClickSiArticoloQuantita() {
      let me = this;
      me.showAlertArticoloPresente = false;
      this.$emit("addQuantitaRigaDocumentoPresente", me.rigaDocumento);
      this.hide();
    },
    onModificaRigaDocumento(row) {
      let me = this;
      me.rigaDocumentoSelezionata = row;
      me.rigaDocumento = { ...row.item };
      me.rigaDocumento.sconto = me.rigaDocumento.sconto * 100;
      me.isModificaRigaDocumento = true;
      this.show();
    },
    onClickNoArticoloQuantita() {
      this.hide();
      this.onResetRigaDocumento();
      if (this.$refs.cmpMagazzinoArticoliGiacenzeListComponent) {
        this.$refs.cmpMagazzinoArticoliGiacenzeListComponent.resetLottoMatricolaRiga();
      }
    },
    onRicercaArticolo() {
      this.ricercaArticolo();
    },
    ricercaArticolo() {
      this.$refs.cmpMagazzinoArticoliGiacenzeListComponent.setFiltroRigaDocumentoOperazione(this.paginationArticoli, this.rigaDocumento, this.jsonData.causaleDocumentoOperazioneMagazzino);
    },

    onChangeUnitaMisura(codiceMoltiplicatore) {
      let um = this.getUnitaMisuraArticoli.filter((e) => e.codiceMoltiplicatore == codiceMoltiplicatore);
      this.setDatiUmRigaDocumento({ umId: um[0].id });
    },
    onChangeIva(codiceIva) {
      this.setDatiIvaRigaDocumento({ codiceIva: codiceIva });
    },

    getDescrizioneAggiuntiDaAggiungere() { },
    onAfterSavedArticolo() { },
    onOkRigaDocumento(event) {
      event.preventDefault();
      let validation = this.validazione();
      if (!validation.esito) {
        this.generaBtoast(validation);
        return;
      }
      if (this.isModificaRigaDocumento) {
        this.$emit("modificaRigaDocumento", this.rigaDocumentoSelezionata.index, this.rigaDocumento);
      } else {
        this.$emit("addRigaDocumento", this.rigaDocumento);
      }
      this.onResetRigaDocumento();
      this.hide();

    },
    onClickAggiungiArticoloNonPresente() {
      this.$refs.cmpContabilitaDocumentoRigaAggiungiArticoloBoxComponent.showBox();
      this.isBoxAggiungiArticoloOpen = true;
    },
    onClickChiudiBoxArticoloNonPresente() {
      this.$refs.cmpContabilitaDocumentoRigaAggiungiArticoloBoxComponent.hideBox();
      this.isBoxAggiungiArticoloOpen = false;
    },
    onSalvaNuovoArticoloChiudi() {
      this.$refs.cmpContabilitaDocumentoRigaAggiungiArticoloBoxComponent.salvaNuovoArticolo();
    },
    onUpdateRowNumberGiacenza(value) {
      this.rowsGiacenza = value;
    },
    getPresidio() {
      let tmpPresidio = window.localStorage.getItem("presidio");
      if (tmpPresidio) {
        this.presidio = JSON.parse(tmpPresidio);
      }
    },
    onRowSelectedLottoMatricola(item) {
      this.rigaDocumento.lottiScadenze = item;
    },
    onAddLottoMatricola(lottoMatricole) {
      this.rigaDocumento.lottiScadenze = lottoMatricole;
    },

    onRowSelectedArticoliItems(item) {


      if (item[0]) {
        this.arraySelezionati.articolo = item;
        let articolo = item[0];
        this.setDatiArticoloScelto(articolo);
        this.setDatiUmRigaDocumento(articolo);
        this.setDatiIvaRigaDocumento(articolo);

      } else {
        this.onResetRigaDocumento();
      }
    },
    setDatiArticoloScelto(articolo) {
      let me = this;
      me.rigaDocumento.descrizione = articolo.nomeArticolo;
      me.rigaDocumento.codiceArticolo = articolo.codiceArticolo;
      me.rigaDocumento.idArticolo = articolo.id;
      me.rigaDocumento.prezzoUnitario = articolo.prezzoAcquistoStandard;
    },
    setDatiIvaRigaDocumento(articolo) {
      let me = this;
      let codiceIva = articolo.codiceIva;
      let ivaObj = me.contabilitaIvaOptions.filter((e) => e.codiceIva == codiceIva);
      if (ivaObj.length > 0) {
        me.rigaDocumento.ivaDescrizione = ivaObj[0].descrizioneIva;
        me.rigaDocumento.ivaAliquota = ivaObj[0].aliquotaIva;
        me.rigaDocumento.ivaCodice = ivaObj[0].codiceIva;
      }
    },
    setDatiUmRigaDocumento(articolo) {
      let me = this;
      let umId = articolo.umId;
      let um = me.magazzinoArticoliUnitaMisuraOptions.filter((e) => e.id == umId);
      if (um.length > 0) {
        let unitaMisura = um[0];
        me.rigaDocumento.umCodice = unitaMisura.codiceMoltiplicatore;
        me.rigaDocumento.umDescrizione = unitaMisura.descrizioneMultiplo;
        me.rigaDocumento.umMultiplo = unitaMisura.multiplo;
      }
    },
    onClickCloseRicercaArticolo(value) {
      this.rigaDocumento[value] = null;
    },
    onResetRigaDocumento() {
      this.rigaDocumento = {
        id: "-1",
        idArticolo: null,
        codiceArticolo: null,
        descrizione: null,
        umCodice: null,
        umDescrizione: null,
        umMultiplo: 0,
        quantita: 1,
        prezzoUnitario: 0,
        sconto: 0,
        ivaCodice: null,
        ivaDescrizione: null,
        ivaAliquota: 0,
        codiceTipoSpesa: null,
        descrizioneImballo: null,
        colli: 0,
        totaleRiga: 0,
        lottiScadenze: [],
        documentoRiferimentoDescrizione: null,
        documentoRiferimentoId: null,
        documentoRiferimentoRigaId: null,
        documentoRiferimentoRigaQuantita: null,
      };
    },
    onHideRigaDocumento() {
      let me = this;
      me.onResetRigaDocumento();
      me.isGestioneLottoMatricole = false;
    },
    validazione() {
      let esito = true;
      let msg = "";
      if (this.arraySelezionati.articolo == null) {
        msg += "Articolo non selezionato ! #";
        esito = false;
      }
      if (this.rigaDocumento.codiceArticolo == null || this.rigaDocumento.codiceArticolo.trim() == "") {
        msg += "Codice Articolo non valido ! #";
        esito = false;
      }
      if (this.rigaDocumento.descrizione == null || this.rigaDocumento.descrizione.trim() == "") {
        msg += "Descrizione Articolo non valido ! #";
        esito = false;
      }
      if (this.rigaDocumento.umCodice == null || this.rigaDocumento.umCodice.trim() == "") {
        msg += "U.M non valido ! #";
        esito = false;
      }
      if (this.rigaDocumento.codiceTipoSpesa == null || this.rigaDocumento.codiceTipoSpesa.trim() == "") {
        msg += "Codice Spesa non valido ! #";
        esito = false;
      }
      if (this.rigaDocumento.ivaCodice == null || this.rigaDocumento.ivaCodice.trim() == "") {
        msg += "Codice Iva non valido ! #";
        esito = false;
      }
      if (this.rigaDocumento.quantita == null || this.rigaDocumento.quantita <= 0) {
        msg += "Quantita non valida ! #";
        esito = false;
      }
      if (this.rigaDocumento.prezzoUnitario == null || this.rigaDocumento.prezzoUnitario < 0) {
        msg += "Prezzo Unitario non valido ! #";
        esito = false;
      }
      if (this.rigaDocumento.sconto == null) {
        msg += "Sconto non valido ! #";
        esito = false;
      }

      if (this.operazioneMagazzino == -1) {
        if (this.arraySelezionati.articolo != null) {
          if (this.arraySelezionati.articolo[0].gestioneMatricole) {
            if (this.arraySelezionati.matricole.length == 0) {
              msg += "Matricole non selezionate ! #";
              esito = false;
            }
            if (this.rigaDocumento.quantita > this.arraySelezionati.matricole.length) {
              msg += "Matricole '" + new Number(this.rigaDocumento.quantita - this.arraySelezionati.matricole.length) + "' ancora da selezionare ! #";
              esito = false;
            }
            if (this.arraySelezionati.matricole.length > this.rigaDocumento.quantita) {
              msg += "Selezionare Massimo " + this.rigaDocumento.quantita + " matricole ! #";
              esito = false;
            }
          }
          if (this.arraySelezionati.articolo[0].gestioneLottiScadenze) {
            if (this.arraySelezionati.lottiScadenze.length == 0) {
              msg += "Lotti Scadenze non selezionati ! #";
              esito = false;
            } else {
              let quantitaSelezionata = 0;
              for (let item of this.arraySelezionati.lottiScadenze) {
                quantitaSelezionata += Number(item.quantita) || 0;
              }

              if (this.rigaDocumento.quantita > quantitaSelezionata) {
                msg += "Lotti '" + new Number(this.rigaDocumento.quantita - quantitaSelezionata) + "' ancora da selezionare ! #";
                esito = false;
              }
            }
          }
        }
      }

      return { esito: esito, msg: msg };
    },
    generaBtoast(validation) {
      let message = validation.msg.split("#");
      const h = this.$createElement;
      const vNodesMsg = h("ul", { style: "margin-left: -18px" }, []);
      message.forEach((element) => {
        if (element.trim() != "") {
          vNodesMsg.children.push({ tag: "li", text: element });
        }
      });
      this.$bvToast.toast([vNodesMsg], {
        title: "Attenzione!",
        autoHideDelay: 5000,
        variant: "danger",
      });
    },
  },
};
</script>

<style scoped>
.sa-flex-box-main-right {
  width: 300px !important;
}


.sa-badge-data {
  padding-right: 2px !important;
}

.sa-badge-data-matricola {
  overflow: visible;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 50px;
}

.sa-badge-group-lotti {
  height: 320px;
  display: block;
  overflow: scroll;
  overflow-x: hidden;
}

.sa-badge-group-matricole {
  height: 400px;
  display: block;
  overflow: scroll;
}

.sa-badge {
  padding: 5px !important;
  transition: all 0.1s linear;
  cursor: pointer;
  max-width: initial;
}

.sa-badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  background-color: rgba(255, 255, 255, 0.651);
}

.sa-badge-ft-disable-class {
  background-color: var(--sa-data-text-color);
  cursor: not-allowed;
  border-left: 3px solid #a71d2a;
}

.sa-badge-ft-active-class {
  transform: translateY(-2px);
  box-shadow: 0 2px 10px rgba(63, 63, 63, 0.2);
  border: 1px solid var(--bg-sidebar) !important;
  border-color: var(--bg-sidebar) !important;
  background-color: var(--bg-button-press-color);
}

.sa-badge-ft-active-class:hover {
  box-shadow: 0 2px 10px rgba(63, 63, 63, 0.2);
  border: 1px solid var(--bg-sidebar) !important;
  border-color: var(--bg-sidebar) !important;
  background-color: var(--bg-button-press-color);
}

.sa-badge-ft-disable-class:hover {
  transform: translateY(0px);
}

.sa-box-matricole {
  background-color: white;
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: opacity 1s ease-in-out;
  top: 0;
  right: 0;
  left: 0;
  padding: 5px;
}

.sa-box-matricole-hidden {
  opacity: 0;
  visibility: hidden;
  transition: all 1s ease-in-out;
}

.sa-box-matricole-visible {
  visibility: visible;
  opacity: 1;
  transition: all 1s ease-in-out;
}

.sa-modal-static-scroll .modal-content {
  height: calc(100vh - 25rem) !important;
}

.row div {
  /* padding-bottom: var(--pd-form-element); */
  padding-bottom: 0px !important;
}
</style>
